module.exports = __webpack_public_path__ + "static/josh1-614c0d74716900e9dc96c5e91ebe4905.jpg";